export default function subColumn (column, type, attributeValue, subColumnProperty) {
	let id = `${type}_${attributeValue}`;
	let name;

	if(!column.subColumns.entities[id]) {
		name = attributeValue;
		column.subColumns.entities[id] = {
			id: id,
			index: column.subColumns.items.length,
			name: name === 'null' ? null : name,
			value: name === 'null' ? null : name,
			column: column,
			property: subColumnProperty,
			type: type,
			rows: []
		};

		column.subColumns.items.push(column.subColumns.entities[id]);
	}

	return column.subColumns.entities[id];
};


/** WEBPACK FOOTER **
 ** ./src/js/lib/schedule_table/sub_column.js
 **/